var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"12","height":"8","viewBox":"0 0 12 8","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M11 1.5L6 6.5L1 1.5","stroke":_vm.color || '#FCC210',"stroke-width":"1.66667"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }